export default "__VITE_ASSET__09b54bec__"